/**
 * @file Minimum JS required for homepage to function.
 */

import vHeader from '../components/header/header';
import vOffCanvasNav from '../components/off-canvas-nav/off-canvas-nav';
import vSearchForm from '../components/search-form/search-form';
import vFullScreenBgText from '../components/full-screen-bg-text/full-screen-bg-text';
import vCardLink from '../components/card-link/card-link';
import vMiniCart from '../components/mini-cart/mini-cart';

const vHomepage = () => {
	vOffCanvasNav();
	vSearchForm();
	vFullScreenBgText();
	vCardLink();
	vMiniCart();
};

if (document.readyState !== 'loading') {
	vHomepage();
} else {
	document.addEventListener('DOMContentLoaded', () => {
		vHomepage();
		vHeader();
		vOffCanvasNav();
	});
}
